import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Welcome } from './components/Welcome';
import { Services } from './components/Services';
import { Mission } from './components/Mission';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Welcome data-id="element-4" />
        <Services data-id="element-5" />
        <Mission data-id="element-6" />
        <Contact data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}